<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 490.1 490.1" style="enable-background:new 0 0 490.1 490.1;" xml:space="preserve">
<g>
	<g>
		<path d="M194.5,324.35l15-24.2c3.6-5.8,1.8-13.3-4-16.9c-5.7-3.6-13.3-1.8-16.9,4l-15,24.2c-27.2,43.9-66,69.1-106.6,69.1H12.2
			c-6.8,0-12.2,5.5-12.2,12.3s5.5,12.3,12.2,12.3h54.9C116.4,404.95,162.8,375.55,194.5,324.35z"/>
		<path d="M486.4,88.75L427,29.25c-4.8-4.8-12.5-4.8-17.3,0s-4.8,12.5,0,17.3l38.6,38.6c-0.1,0-0.1,0-0.2,0h-56.7
			c-49.2,0-95.7,29.4-127.4,80.6l-9.2,14.9c-3.6,5.8-1.8,13.3,4,16.9c2,1.2,4.2,1.8,6.4,1.8c4.1,0,8.1-2.1,10.4-5.8l9.2-14.9
			c27.2-43.9,66-69,106.6-69H448c0.1,0,0.1,0,0.2,0l-38.6,38.6c-4.8,4.8-4.8,12.5,0,17.3c2.4,2.4,5.5,3.6,8.7,3.6s6.3-1.2,8.7-3.6
			l59.5-59.5C491.2,101.25,491.2,93.45,486.4,88.75z M460.3,97.55c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2l0.2,0.2L460.3,97.55z"/>
		<path d="M409.6,460.85c2.4,2.4,5.5,3.6,8.7,3.6s6.3-1.2,8.7-3.6l59.5-59.5c4.8-4.8,4.8-12.5,0-17.3l-59.5-59.4
			c-4.8-4.8-12.5-4.8-17.3,0s-4.8,12.5,0,17.3l38.6,38.6c-0.1,0-0.1,0-0.2,0h-54.9c-40.5,0-79.4-25.2-106.6-69.1l-90.2-145.7
			c-31.7-51.3-78.2-80.6-127.4-80.6H12.2c-6.8,0-12.2,5.5-12.2,12.3s5.5,12.3,12.2,12.3h56.7c40.5,0,79.4,25.2,106.6,69l90.2,145.7
			c31.7,51.3,78.2,80.7,127.4,80.7H448c0.1,0,0.1,0,0.2,0l-38.6,38.6C404.9,448.35,404.9,456.05,409.6,460.85z M460.3,392.55
			l0.2,0.2l-0.2,0.2c0-0.1,0-0.1,0-0.2S460.3,392.65,460.3,392.55z"/>
	</g>
</g>
</svg>
